import {createRoot} from "react-dom/client";
import {createGameController} from "../public/js/game/gameController.js";
import {App} from "./App.jsx";

const controller = createGameController();

// Browsers only allow audio after a gesture; the first tap anywhere unlocks it.
window.addEventListener("pointerdown", () => controller.soundBoard.prime(), {once: true});

// pagehide also fires when the page enters the bfcache, which on iOS means every
// app switch. Closing the lobby on those would kick everyone out mid-party.
window.addEventListener("pagehide", (event) => {
  if (!event.persisted) controller.closeLobbyOnPageExit();
});

createRoot(document.getElementById("root")).render(<App controller={controller} />);
controller.boot();
